import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import 'firebase/database';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    companies: {},
    notes: '',
    streams: []
  },
    getters: {
      getCompanies(state) {
        return state.companies;
      },
      getNotes(state) {
        return state.notes;
      },
      getStreams(state) {
        return state.streams;
      }
    },
  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies;
    },
    SET_NOTES(state, notes) {
      state.notes = notes;
    },
    SET_STREAMS(state, streams) {
      state.streams = streams;
    }
  },
  actions: {
    async loadCompanies({commit}) {
      const db = firebase.database();
      const companies: any = [];
      const snapshot = await db.ref('companies').once('value');

      snapshot.forEach((item) => {
        companies.push(item.val());
      });
      commit('SET_COMPANIES', companies);
    },
    async loadStreams({commit}) {
      const db = firebase.database();
      const snapshot = await db.ref('streams').once('value');
      commit('SET_STREAMS', snapshot.val());
    },
      async loadNotes({commit}) {
        const db = firebase.database();
        const snapshot = await db.ref('logistics/notes/text').once('value');
        if (snapshot) {
          commit('SET_NOTES', snapshot.val());
        } else {
          commit('SET_NOTES', '');
        }
      },
      setNotes({commit}, notes) {
        commit('SET_NOTES', notes);
      },
  },
});
